import React, {useState, useEffect} from 'react'
import ButtonContainer from '../Components/ButtonContainer';
import COLORS from '../Colors';
import '../Styles/StartEndScreen.css';
import { withRouter } from "react-router-dom";
import TextField from "../Components/TextField"
import { PATH_NAMES } from '../Utilities/Constants';


//The page after a user completes the assessment
function ScreeningID(props) {
    // console.log(`API_URL:${process.env.API_URL}`);
    const [id, setID] = useState("");

    useEffect(() => {
      sessionStorage.clear();
    });

    function clickNext() {

        console.log(id)

        sessionStorage.setItem('screening_id', id);

        props.history.push({
            pathname: PATH_NAMES.STAFF
          })
      }


    var fieldComponent = <TextField
        id = 'screening_id'
        placeholder = "ID"
        update_text = {setID}
    />;

  return (
    <>
       <div className='card'>
          <h1 className='card-title'>Welcome, </h1>
          <p className='card-text'>
            Please enter the patient's study ID:
          </p>
          {fieldComponent}
          <ButtonContainer
            colors={[COLORS.green]}
            buttonTexts={['Continue to assessment']}
            buttonType='filled'
            onClick={() => clickNext()}
          />
        </div>
    </>
  );
}
export default withRouter(ScreeningID);



